export { default } from "./getScrollbarSize.js";